module.exports = __webpack_public_path__ + "img/KM-360A_10.d3bfe1d3.jpg";